import React from 'react';
import { AGridColDef } from '../../../../common/data-grid/ADataGridColDef';
import ADataGrid from '../../../../common/data-grid/ADataGrid';
import { gridStyles } from '../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { gridComponents } from '../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import NoRowOverlay from '../../../../masters/holidayMaster/NoRowOverlay';
import { Tooltip } from '@mui/material';
import moment from 'moment';


const ReceiptIndexList = ({
    receiptIndexData,
}) => {

    const { data, fetching } = receiptIndexData;

    const getFormatedDate = (date, timeRequired) => timeRequired ? moment(date)?.format("DD/MM/YYYY hh:mm A") : moment(date)?.format("DD/MM/YYYY")

    const columns = [

        new AGridColDef('srNo', 'Sr No.', false)
            .setMinWidth(50)
            .setFlex(0.2)
            .editable(true)
            .setValueGetter(params => params?.value),

        new AGridColDef('type', 'Type', false)
            .setMinWidth(120)
            .setFlex(0.8)
            .editable(true)
            .renderCellComponent((params) =>
                params?.value ? (
                    <Tooltip title={params?.value}>
                        <div className="ellipsis-text-container">
                            {params?.value}
                        </div>
                    </Tooltip>
                ) : (
                    <div className="m-auto">-</div>
                )
            ),

        new AGridColDef('effectiveDate', 'Effective Date', false)
            .setMinWidth(80)
            .setFlex(0.5)
            .editable(true)
            .setValueGetter(params => getFormatedDate(params?.value)),

        new AGridColDef('year', 'Year', false)
            .setMinWidth(50)
            .setFlex(0.2)
            .editable(true)
            .setValueGetter(params => params?.value),

        new AGridColDef('receiptLabel', 'Code', false)
            .setMinWidth(50)
            .setFlex(0.2)
            .editable(true)
            .setValueGetter(params => params?.value),

        new AGridColDef('lastIndexNumber', 'Last Index No.', false)
            .setMinWidth(110)
            .setFlex(0.4)
            .editable(true)
            .setValueGetter(params => params?.value),


        new AGridColDef('updatedOn', 'Last Updated On', false)
            .setMinWidth(150)
            .setFlex(1.2)
            .editable(true)
            .renderCellComponent((params) =>
                params?.value ? (
                    <Tooltip title={`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}>
                        <div className="ellipsis-text-container">
                           {`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}
                        </div>
                    </Tooltip>
                ) : (
                    <div className="m-auto">-</div>
                )
            )
    ]

    return (

        <ADataGrid
            removeWrapperContainer
            rows={data || []}
            columns={columns}
            rowId={(row) => row.id}
            rowHeight={50}
            loading={false}
            components={{
                ...gridComponents,
                NoRowsOverlay: () => (
                    <NoRowOverlay message={fetching ? "Loading..." : null} />
                ),
            }}
            sx={gridStyles}
            autoHeight
            hidePagination
            serverPagination={false}
        />

    );
}

export default ReceiptIndexList;